import { Button, Popover } from "@mui/material";
import React, { CSSProperties } from "react";
import { getClasses } from "shared/helpers/styleHelper";

export const ColorInput = (props: ColorInputProps) => {
  const { value, options, onChange } = props;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button className="module-color-input-btn" onClick={handleClick} color='secondary'>
        <div className="module-color-sqr" style={{ "--color": value } as CSSProperties} />
      </Button>
      <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            className: "module-color-input-popover",
            style: { width: "490px" },
          },
        }}
      >
        {options.map((option) => (
          <div
            key={option}
            className={getClasses({
              "module-color-sqr": true,
              "is-selected": value === option,
            })}
            style={{ "--color": option } as CSSProperties}
            onClick={() => {
              onChange(option);
              handleClose();
            }}
          />
        ))}
      </Popover>
    </>
  );
};

interface ColorInputProps {
  value: string;
  options: string[];
  onChange: (color: string) => void;
}
